import vm from '@/main.js'
import axios from 'axios'
import router from '../router'
import store from '@/store'

import {getToken, removeToken} from '@/utils/auth'


function request(data, { showLoad = false } = {}) {
  const baseURL = process.env.VUE_APP_BASE_API
  const service = axios.create({
    baseURL,
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 600 * 1000, // request timeout
    validateStatus: function (status) {
      return status != 404
    },
  })

  service.interceptors.request.use(
    config => {
      config.headers.post['Content-Type'] = 'application/json;charse=UTF-8'
      config.headers['token'] = getToken()
      if (showLoad) {
        vm.showLoad = vm.$loading({
          text: '加载中...',
          lock: true,
          background: 'rgba(0, 0, 0, 0.6)',
        })
      }

      // 空字符串参数转为null
      const params = config.params || config.data

      if (({}).toString.call(params) == '[object Object]') {
        for (var i in params) {
          if (params[i] && typeof params[i] == 'string') {
            params[i] = params[i].replace(/^\s+|\s+$/g, '')
          }
          if (params[i] == null || params[i] === '') {
            delete params[i]
          }
        }
      }

      return config
    },
    error => {
      console.log(error) // for debug
      return Promise.reject(error)
    }
  )

  let toLoginTimes = 0
  service.interceptors.response.use(
    response => {
      vm.showLoad && vm.showLoad.close()
      // console.log(response)
      const status = response.status
      const res = response.data
      const code = res.code

      if (status === 200 || status === 204) {
        if (!code) {
          return res
        } else if (code === 300) { // 登录过期
          if (toLoginTimes === 0) {
            toLoginTimes++
            store.dispatch('user/resetToken').then(() => {
              vm.$router.replace({
                name: "login"
              });
            });
          }
          return Promise.reject(new Error(res.message || 'Error'))
        } else if (code == 200) { // 操作成功
          return res.data
        } else if (code == 1) { // 操作成功
          return res.data
        } else {
          vm.$toast(res.message || 'Error');
        }
        return Promise.reject(new Error(res.message || 'Error'))
      } else {
        return Promise.reject(new Error(response.statusText || 'Error'))
      }
    },
    error => {
      vm.showLoad && vm.showLoad.close()
      vm.$toast(error.message || 'Error');
      return Promise.reject(error)
    }
  )

  return service(data)
}

export default request
